/**
 * Mobile Navigation — Responsive Hamburger Menu
 *
 * Dynamically adds a hamburger toggle + mobile menu panel to any page
 * with a nav.nav-glass element. Desktop links must have class "hidden md:flex"
 * to be hidden on mobile (applied via HTML).
 */
(function () {
  var nav = document.querySelector('nav.nav-glass');
  if (!nav) return;

  var section = nav.querySelector('.section');
  if (!section) return;

  var desktopLinks = section.querySelector('.hidden.md\\:flex');
  if (!desktopLinks) return;

  // Create mobile CTA + hamburger container (visible on mobile only)
  var mobileActions = document.createElement('div');
  mobileActions.className = 'md:hidden flex items-center gap-3';

  // Mobile "Get Started" CTA
  var mobileCta = document.createElement('a');
  mobileCta.href = '#destinations';
  mobileCta.className = 'bg-coral text-white text-xs font-semibold px-3 py-1.5 rounded-lg';
  mobileCta.textContent = 'Get Started';
  mobileActions.appendChild(mobileCta);

  // Create hamburger button (visible on mobile only)
  var btn = document.createElement('button');
  btn.id = 'mobile-menu-btn';
  btn.className = 'p-2 -mr-2';
  btn.setAttribute('aria-label', 'Toggle menu');
  btn.setAttribute('aria-expanded', 'false');
  btn.innerHTML =
    '<svg class="w-6 h-6 text-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>' +
    '</svg>';
  mobileActions.appendChild(btn);
  section.appendChild(mobileActions);

  // Build mobile menu from desktop links
  var mobileMenu = document.createElement('div');
  mobileMenu.id = 'mobile-menu';
  mobileMenu.className = 'hidden md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-40';

  var menuContent = document.createElement('div');
  menuContent.className = 'px-6 py-4 flex flex-col gap-1';

  var links = desktopLinks.querySelectorAll('a');
  links.forEach(function (link) {
    var mobileLink = link.cloneNode(true);
    if (link.classList.contains('btn-primary')) {
      mobileLink.className = 'btn-primary text-center py-3 rounded-lg text-sm font-semibold mt-2';
    } else {
      mobileLink.className = 'block text-base text-navy/80 hover:text-coral transition-colors font-medium py-3 border-b border-gray-100';
    }
    menuContent.appendChild(mobileLink);
  });

  mobileMenu.appendChild(menuContent);
  nav.appendChild(mobileMenu);

  var hamburgerIcon =
    '<svg class="w-6 h-6 text-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>' +
    '</svg>';
  var closeIcon =
    '<svg class="w-6 h-6 text-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>' +
    '</svg>';

  btn.addEventListener('click', function () {
    var isOpen = !mobileMenu.classList.contains('hidden');
    mobileMenu.classList.toggle('hidden');
    btn.setAttribute('aria-expanded', String(!isOpen));
    btn.innerHTML = isOpen ? hamburgerIcon : closeIcon;
  });

  // Close menu on link click
  mobileMenu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      mobileMenu.classList.add('hidden');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = hamburgerIcon;
    });
  });
})();
